import { LifeStructure } from './life-structure';
import { CoverageType } from './coverage-type';
import { Applicant } from './applicant';
import { Employee } from './employee';
import { Notice } from './notice';
import { AgencyLocation } from '../agency-location';
import { MhsApplication } from '../mhs-application';
import { CoverageMhs } from './coverage-mhs';
import { Questions } from '../ui/questions';
import { ApplicantType } from '../ui/applicant-type';
import { GroupEdp } from '../group-edp';

export class UserSession {
    applicantTypes: ApplicantType[];
    applicantType: string;
    selectedApplicantTypes: string[]; // Array of selected applicant type abbreviations
    childCount: number; // Number of children selected
    submittedApplicantTypes: string[] = []; // Array of submitted applications (e.g., "Employee", "Spouse", "Child-1", "Child-2")
    currentChildNumber: number; // Current child number being processed (1-5)
    agencyLocations: AgencyLocation[];
    agencyLocation: string;
    agencyLocationLabel: string;
    formNumber: string;
    companyId: string;
    dataTheme: string;
    policy: number;
    grpName: string;
    state: string;
    country: string;
    consent: boolean;
    employee: Employee;
    applicant: Applicant;
    notices: Notice[];
    mhsAnswers: object; // can't print Map<string,string> to console...
    mhsId: string;
    pdfId: string;
    submitDate: Date;
    sessionEnded: boolean = false;
    sessionTimedOut: boolean = false;
    mhsApplication: MhsApplication;
    mhsCoverages: CoverageMhs[];
    newMhsQuestions: Questions;
    edpGroupData: GroupEdp;
    maintenance_mode: boolean = false;
    maintenance_time: string;
    physicianRequiredQuestions: string[];
    answeredYesToRequiredPhysicianQuestion: boolean = false;
    hasFraudNotice: boolean = false;
    isGenericDynamicForm: boolean = false;
    isContinuingFromConfirmation: boolean = false; // Flag to indicate starting new applicant from confirmation
    preservedPolicyData: any; // Store policy page data
    preservedStateData: any; // Store state of residence data
    preservedEmployeeData: any; // Store employee information data
    
    // Helper method to get submission identifier (e.g., "Employee", "Spouse", "Child-1")
    getSubmissionIdentifier(): string {
        if (this.applicantType?.toLowerCase() === 'child' && this.currentChildNumber) {
            return `Child-${this.currentChildNumber}`;
        }
        return this.applicantType?.charAt(0).toUpperCase() + this.applicantType?.slice(1);
    }
}
